import fs from 'fs';
import { parse } from 'yaml';
import { HEXASYNC_CONNECTOR_CONFIG } from './cluserHelper';

export function findConnectorById(connectorId: string) {
  var connectorConfigPath = HEXASYNC_CONNECTOR_CONFIG;
  var connectorConfigs =
    parse(fs.readFileSync(connectorConfigPath, 'utf8')) || {};
  var connectors = connectorConfigs.connectors || [];
  var result = connectors.find((c: any) => c.connectorId === connectorId);
  return result;
}
